const getOffSet = (el) => {
  const rect = el.getBoundingClientRect();
  return {
    top: rect.top + window.pageYOffset,
    left: rect.left + window.pageXOffset,
    offsetHeight: rect.height
  };
}

// Listen for scroll event to hide element when element reaches the top of the element passed
export const stickyHide = (el, offset) => {
  const offsetTop = getOffSet(el).top;
  // const offsetBottom = getOffSet(el).top + el.offsetHeight;
  const scrollTop = window.pageYOffset;
  // const scrollBottom = scrollTop + window.innerHeight;
  if (scrollTop > offsetTop - offset - el.offsetHeight) {
    return false
  } else {
    return true
  }
}